import { model } from "core/util";
import { PensionBeneficiaryShare as PensionBeneficiaryShareType, PensionBeneficiaryShareDto } from "types";

export const PensionBeneficiaryShare = model.createModel<PensionBeneficiaryShareDto, PensionBeneficiaryShareType>((json) => ({
    numerator: json.Numerator,
    denominator: json.Denominator,
    shareType: json.ShareType,
}));
